<div
  class="keypad-input-class"
  [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_INPUT"
  [class.display-active]="isActive"
  [class.display-error]="isInvalid || errorMessage"
  [ngClass]="className"
>
  @if (prefix) {
    <div class="prefix">{{ prefix }}</div>
  }
  <keypad-input
    [value]="displayedValue"
    [placeholder]="placeholder"
    [kpType]="kpType"
    [isDefaultMinValue]="isDefaultMinValue"
    [measure]="measure"
    [mask]="mask"
    [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_INPUT_ELEMENT"
    (change)="currentValue = $event"
    [ngClass]="className"
    class="display-value"
  >
  </keypad-input>
  @if (currentValue) {
    <div
      class="popper"
      [attr.e2e-attr]="E2E_ATTRIBUTES.POPPER"
      (click)="onPop()"
    >
      <!-- TODO: dark theme should check this icon is availiable -->
      @if (kpType === 'pinReceiver') {
        <div>
          <img
            align="center"
            src="{{ 'assets/img/backspace_light.svg' | xeaSourcePath }}"
            class="bspIcon"
          />
        </div>
      } @else {
        <img
          align="center"
          src="{{ 'assets/img/backspace_light.svg' | xeaSourcePath }}"
          class="bspIcon"
        />
      }
    </div>
  }
  <!-- specific error message for specified keypad-display input -->
  @if (errorMessage) {
    <div
      class="x_input-error-msg"
      [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_DISPLAY_ERROR_MESSAGE"
    >
      {{ errorMessage }}
    </div>
  }
</div>
